const RELEASE_PREFIXES = ['/assets/', '/Audio/', '/dist/'];

export function releaseAssetUrl(value) {
  const path = String(value || '');
  const base = String(globalThis.window?.__RELEASE_BASE__ || '').replace(/\/+$/, '');
  if (!base || !path.startsWith('/') || path.startsWith(`${base}/`)) return path;
  return RELEASE_PREFIXES.some((prefix) => path.startsWith(prefix)) ? `${base}${path}` : path;
}

export function runtimeAssetUrl(value) {
  const path = String(value || '');
  const base = String(globalThis.window?.__RELEASE_BASE__ || '').replace(/\/+$/, '');
  // The worker and its relative JS/WASM imports must belong to one immutable
  // release. A query on just the root worker cannot version its dependencies.
  if (base && path.startsWith('/')) return path.startsWith(`${base}/`) ? path : `${base}${path}`;
  const releaseId = String(globalThis.window?.__RELEASE_ID__ || 'dev');
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}release=${encodeURIComponent(releaseId)}`;
}
